import { render } from "./EditUserView.vue?vue&type=template&id=bbaa6e28&ts=true"
import script from "./EditUserView.vue?vue&type=script&lang=ts"
export * from "./EditUserView.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/femers/git/adminSanatorio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__